/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailDto
 */
export interface EmailDto {
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    email: string;
}

/**
 * Check if a given object implements the EmailDto interface.
 */
export function instanceOfEmailDto(value: object): value is EmailDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function EmailDtoFromJSON(json: any): EmailDto {
    return EmailDtoFromJSONTyped(json, false);
}

export function EmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

  export function EmailDtoToJSON(json: any): EmailDto {
      return EmailDtoToJSONTyped(json, false);
  }

  export function EmailDtoToJSONTyped(value?: EmailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

